//shared helpers for the leave services.

export const extractRows = (body) => {
    if(Array.isArray(body)) return body;
    if(Array.isArray(body?.resultSet)) return body.resultSet;
    if(Array.isArray(body?.ResultSet)) return body.ResultSet;
    if(Array.isArray(body?.data)) return body.data;
    if(Array.isArray(body?.data?.resultSet)) return body.data.resultSet;
    if(Array.isArray(body?.data?.ResultSet)) return body.data.ResultSet;
    return[];
};

export const toDateKey = (date) => {
    if(!date) return "";
    const d = new Date(date);
    if(isNaN(d.getTime())) return String(date);
    const p = (n) => String(n).padStart(2,"0");
    return `${d.getFullYear()}-${p(d.getMonth()+1)}-${p(d.getDate())}`;
};

export const assertOk = (body) => {
  const code = body?.statusCode ?? body?.StatusCode;
  if (code !== undefined && code !== 200) {
    const msg = String(body?.Result || body?.Message || `Server error (status ${code})`);
    throw new Error(msg.split("\n")[0].trim());
  }
  return body;
};

export const toEmployeeOptions = (raw) =>
  extractRows(raw)
    .map((e) => {
      const serviceNo = String(e.serviceNo ?? e.ServiceNo ?? "").trim();
      return {
        serviceNo,
        name: e.reportName || e.ReportName || e.name || serviceNo,
        department: e.department || e.DepartmentCode || e.Designation || "",
      };
    })
    .filter((e) => e.serviceNo);